<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb" />
    <text-title :mainTitle="mainTitle" />
    <form>
     <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">车位号：</span>
        </div>
        <el-input v-model="formData.parkLotNumber" size="small" style="width: 280px" />
      </div>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">是否固定车位：</span>
        </div>
        <el-select v-model="formData.fix" size="small" style="width: 280px">
            <el-option label="是" :value="true">是</el-option>
            <el-option label="否" :value="false">否</el-option>
        </el-select>
      </div>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">车位区域：</span>
        </div>
        <el-select v-model="formData.areaName"
                   filterable
                   remote
                   reserve-keyword
                   size="small" style="width: 280px"
                   :remote-method="remoteMethod"
                   placeholder="请选择车位区域">
          <el-option v-for="item in parkingLotAreaList" :key="item.code"
                     :label="item.parkingLotAreaName" :value="item.parkingLotAreaName">
          </el-option>
        </el-select>              
      </div>  
       <div class="form-btn-box">
        <button-confirm @confirm="confirm" />
        <button-cancel @cancel="cancel" />
      </div>
    </form>
  </div>
</template>

<script>
import Breadcrumb from "../../../components/Breadcrumb/Breadcrumb";
import TextTitle from "../../../components/Text/TextTitle";
import ButtonConfirm from "../../../components/Button/ButtonConfirm";
import ButtonCancel from "../../../components/Button/ButtonCancel";
import { errorHandler } from "../../../utils/errorHandler";
import { api } from "../../api/ParkingService";
import { nError, nSuccess } from "../../../utils/notice";
import { pattern } from "../../../utils/regular";
export default {
  components: {
    ButtonCancel,
    ButtonConfirm,
    TextTitle,
    Breadcrumb
  },
  name: "parking-lot-modify",
  data() {
    return {
      breadcrumb: [
        {
          value: "智慧停车",
          name: "parking-device-management"
        },
        {
          value: "车位管理"
        }
      ],
      mainTitle: "修改车位",

      formData: {
        code: "",
        parkLotNumber: "",
        fix: ""
      },
      areaCode: "",
      parkingLotAreaList: []
    };
  },
  created() {
    this.formData.code = this.$route.params.id;
    this.getParkingLotByCode();
    this.remoteMethod();
  },
  methods: {
    remoteMethod() {
      this.getParkingLotAreaList();
    },
    getParkingLotAreaList() {
      this.$axios
        .post(api.getParkingLotAreaList, {})
        .then(res => {
          this.parkingLotAreaList = res.data.data;
        })
        .catch(errorHandler("获取车位区域列表失败"));
    },
    toParkingLotManagePage() {
      this.$router.push({
        name: "parking-lot-manage"
      });
    },
    getParkingLotByCode() {
      this.$axios
        .get(`${api.getParkingLotByCode}/${this.$route.params.id}`, {})
        .then(res => {
          if (res.data.retCode === 1) {
            this.formData = res.data.data;
          }
        })
        .catch(errorHandler("获取信息失败"));
    },
    confirm() {
      if (!this.formData.parkLotNumber) {
        nError("请输入车位号");
        return false;
      }
      this.$axios
        .post(api.updateParkingLot, this.formData)
        .then(res => {
          if (res.data.retCode === 1) {
            nSuccess("修改成功");
            this.toParkingLotManagePage();
          }
        })
        .catch(errorHandler("当前固定车位已经绑定车牌，不能修改未非固定车位"));
    },
    cancel() {
      this.toParkingLotManagePage();
    }
  },
  watch: {
    "formData.areaName": {
      handler(val, oldVal) {
        if (val != oldVal && oldVal) {
          this.parkingLotAreaList.map(v => {
            if (v.parkingLotAreaName == val) {
              this.formData.areaCode = v.code;
            }
          });
        }
      },
      deep: true
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/view/ParkingService/ParkingLot/ParkingLotModify.vue